import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { format, formatDistance, formatRelative, subDays } from "date-fns";
import Spinner from '../../helper/Spinner'
export default function Purchasedquery() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [spinner, setSpinner] = useState(false);


  //set today for second input (endDate) type date
/*   useEffect(() => {
    var date = new Date();

    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;

    var today = year + "-" + month + "-" + day;
    setEndDate(today);
  }, []); */

    //set startDAte input to 7 days ago
    useEffect(() => {
      let oneDaysAgo: Date = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000);
      oneDaysAgo = oneDaysAgo.toISOString().slice(0, 10);
      console.log(oneDaysAgo);
      setEndDate(oneDaysAgo);
    }, []);
  //set startDAte input to 7 days ago
  useEffect(() => {
    let sevenDaysAgo: Date = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    sevenDaysAgo = sevenDaysAgo.toISOString().slice(0, 10);
    console.log(sevenDaysAgo);
    setStartDate(sevenDaysAgo);
  }, []);

  const HandleQuery = async () => {
    try {
      setSpinner(true)
      const response = await fetch(
        `Peacock/Monitoring?start=${startDate}&end=${endDate}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      console.log(response);
      //const payload = await response.json();
      //setData(payload);
      const payload = await response.blob();
      console.log("Payload : ", payload);

      const url = window.URL.createObjectURL(new Blob([payload]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute(
        "download",
        `Monitoring_Einkauf_${startDate}_bis_${endDate}.xlsx`
      );

      document.body.appendChild(link);
      link.click();

      link.remove();
setSpinner(false)
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
      alert('something went wrong')
setSpinner(false)

    }
  };

  format(new Date(), "'Today is a' eeee");
  //=> "Today is a Friday"

  formatDistance(subDays(new Date(), 3), new Date(), { addSuffix: true });
  //=> "3 days ago"

  formatRelative(subDays(new Date(), 3), new Date());
  //=> "last Friday at 7:26 p.m."
  return (
    <div className="container ml-3">
      <div className="d-flex justify-content-between align-items-center w-50 flex-wrap">
        <div>
          <label className="mr-1" htmlFor="startDate">
            Von:
          </label>
          <input
            type="date"
            id="startDate"
            name="startDate"
            defaultValue={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
          />
        </div>
        <div>
          <label className="mr-1" htmlFor="endDate">
            Bis:
          </label>
          <input
            type="date"
            id="endDate"
            name="endDate"
            defaultValue={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
          />
        </div>
        <Button
          outline
          color="success"
          onClick={() => {
            HandleQuery();
          }}
        >
          Download
        </Button>
      </div>
      <div style={{marginTop: '20px'}}>
      {spinner && 
      <Spinner ></Spinner>
    }
    </div>
    </div>
  );
}
